import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Divider from "@material-ui/core/Divider";

import { useStyles } from "./MobileDrawer.css";
import MenuDrawer from "../MenuDrawer/MenuDrawer";
import { publicImageUrl } from "../../../../../Config/publicImageUrl";

class MobileDrawer extends Component {
  render() {
    const { classes, schoolDetails } = this.props;
    return (
      <SwipeableDrawer
        anchor="left"
        open={this.props.mobileOpen}
        onOpen={this.props.handleToggleDrawer}
        onClose={this.props.handleToggleDrawer}
        classes={{
          paper: classes.drawerPaper,
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {schoolDetails ? (
          <div
            style={{
              display: "flex",
              padding: 10,
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#eee",
            }}
          >
            <b>{schoolDetails.schoolName}</b>
            <br />
            {schoolDetails.schoolLogo && (
              <img
                src={`${publicImageUrl}/${schoolDetails.schoolLogo}`}
                alt={schoolDetails.schoolName}
                style={{ width: 150, height: 150 }}
              />
            )}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              padding: 10,
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#eee",
            }}
          >
            School Management System
          </div>
        )}
        <Divider />
        <MenuDrawer role={this.props.role} />
      </SwipeableDrawer>
    );
  }
}

export default withStyles(useStyles)(MobileDrawer);
